module.exports = __webpack_public_path__ + "static/media/DSC_6429.d0f2a71a.JPG";